import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Loader from '@commoncomponents/frontend-components/dist/components/Loader';
import { ListType } from '../../constants';
import AccountsList from './AccountsList';
import EmptyAccountsList from './EmptyAccountsList';
import { LoaderWrapper } from '../../styled';
const AccountsListView = ({ translations, accountsList, currentUserEmail, isUpgradeWithPaymentView, isMobileView, areAccountsLoading, handleChangeUserForPaymentState, setShowCodeInputBar, }) => {
    const [afterFirstRenderWithAccounts, setAfterFirstRenderWithAccounts] = useState(false);
    const areThereAnyAccounts = accountsList && accountsList.length > 0;
    useEffect(() => {
        if (isUpgradeWithPaymentView) {
            if (afterFirstRenderWithAccounts || !accountsList) {
                return;
            }
            if (Array.isArray(accountsList) &&
                accountsList.length > 0 &&
                !afterFirstRenderWithAccounts) {
                setAfterFirstRenderWithAccounts(true);
                let areAllUnchecked = true;
                let currentUserIdx;
                for (let i = 0; i < accountsList.length; i++) {
                    if (accountsList[i].checked) {
                        areAllUnchecked = false;
                    }
                    if (accountsList[i].boxIdentifier === currentUserEmail) {
                        currentUserIdx = i;
                    }
                }
                if (areAllUnchecked) {
                    handleChangeUserForPaymentState(accountsList[currentUserIdx], true);
                }
            }
        }
    }, [accountsList]);
    if (!accountsList || areAccountsLoading) {
        return (React.createElement(LoaderWrapper, null,
            React.createElement(Loader, { active: true })));
    }
    return (React.createElement(Wrapper, null, areThereAnyAccounts ? (React.createElement(AccountsList, { header: translations.accountHeader, youText: translations.youText, expirationText: translations.expirationText, expirationShortText: translations.expirationShortText, listType: isUpgradeWithPaymentView ? ListType.CHECKBOX : ListType.RADIO, accountsList: accountsList, currentUserEmail: currentUserEmail, isMobileView: isMobileView, handleChangeUserForPaymentState: handleChangeUserForPaymentState, setShowCodeInputBar: setShowCodeInputBar })) : (React.createElement(EmptyAccountsList, { emptyListHeader: translations.emptyListHeader, emptyListDescription: translations.emptyListDescription }))));
};
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  overflow: hidden;

  ::-webkit-scrollbar {
    background-color: #f0f2f4;
    height: 119px;
    width: 12px;
  }

  ::-webkit-scrollbar-thumb:vertical {
    background-color: #c4c4c4;
    border-radius: 16px;
    border: 2px solid transparent;
    background-clip: content-box;
  }
`;
export default AccountsListView;
